import { render, staticRenderFns } from "./medicalSolutions.vue?vue&type=template&id=52ce4c20&"
import script from "./medicalSolutions.vue?vue&type=script&lang=js&"
export * from "./medicalSolutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports